import { getCuratorEvents } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import {
  type CuratorEventsServiceResponse,
  CuratorEventsServiceResponseSchema,
} from './events.dto';

const transformCuratorEventsResponse = async (): Promise<CuratorEventsServiceResponse> => {
  const body = await getCuratorEvents();
  return { events: body.data.events };
};

export const getEventsService = withServiceErrorCapture(
  lazyPipe(
    transformCuratorEventsResponse,
    validateServiceResponse(CuratorEventsServiceResponseSchema),
  ),
);
